import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '../button/button.module';
import { MessageComponent } from './message/message.component';
import { IconModule } from '../icon/icon.module';

@NgModule({
  declarations: [MessageComponent],
  imports: [CommonModule, ButtonModule, IconModule],
  exports: [MessageComponent],
})
export class MessageModule {}
